export default {
      id: "medical-history-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "sprite.svg#medical-history",
      toString: function () {
        return this.url;
      }
    }